import { useTranslation } from 'react-i18next';
import type {
  SurveyColumnOptions,
  SurveyResponsesColumnKeys,
} from '../../../../domain/Surveys/Responses/SurveyResponsesColumns';
import { COLUMNS_OPTIONS_DEFAULT } from '../../../../domain/Surveys/Responses/SurveyResponsesColumns';

export const useTranslatedColumnsOptions = (): SurveyColumnOptions => {
  const { t } = useTranslation('feedback');

  return Object.keys(COLUMNS_OPTIONS_DEFAULT).reduce((translatedColumnOptions, nextOptionKey) => {
    const nextOption = COLUMNS_OPTIONS_DEFAULT[nextOptionKey as SurveyResponsesColumnKeys];
    return {
      ...translatedColumnOptions,
      [nextOptionKey]: {
        ...nextOption,
        label: t(`survey-response.table.header.${nextOption.label}`),
      },
    };
  }, COLUMNS_OPTIONS_DEFAULT);
};
